import { JSX } from 'react'

import { Button } from '~/components/component-library'
import { useAuth } from '~/context/AuthProvider'

export const SignInButton = ({
  fluid,
  text = 'Sign in or register',
}: {
  fluid?: boolean
  text?: string
}): JSX.Element => {
  const { setLoginModalState } = useAuth()

  return (
    <Button
      fullWidth={fluid}
      onClick={() => setLoginModalState(true)}
      eventName={'openSignUp'}
    >
      {text}
    </Button>
  )
}
